import {
	connect
} from 'react-redux'
import FittingRecordsComponent from '../components/FittingRecordsComponent.jsx';
import {
	closeFittingRecordModal,
	findDetailsNeedBespoke
} from '../actions';

const mapStateToProps = (state) => ({
	orderId: state.getIn(['fittingReducer', 'orderId']),
	showFittingRecordModal: state.getIn(['fittingReducer', 'showFittingRecordModal']),
})

const mapDispatchToProps = (dispatch) => ({
	closeModal: () => {
		dispatch(closeFittingRecordModal());
	},
	findDetailsNeedBespoke: (payload) => {
		dispatch(findDetailsNeedBespoke(payload));
	},
})

const FittingRecordsContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(FittingRecordsComponent)

export default FittingRecordsContainer;


// WEBPACK FOOTER //
// ./src/containers/FittingRecordsContainer.jsx